/** 图层动画列表编辑。 */
import { Button, Collapse, InputNumber, Select, Space } from 'antd';
import { DeleteOutlined, PlusOutlined } from '@ant-design/icons';
import { PRESET_LIST, type Animation } from '@h5/schema';
import { Field } from './Field';

const GROUP_LABEL: Record<string, string> = { in: '进入', emphasis: '强调', out: '退出' };
const PRESET_OPTIONS = (['in', 'emphasis', 'out'] as const).map((g) => ({
  label: GROUP_LABEL[g],
  options: PRESET_LIST.filter((p) => p.group === g).map((p) => ({ label: p.label, value: p.name })),
}));
const EASINGS = ['ease', 'ease-in', 'ease-out', 'ease-in-out', 'linear', 'cubic-bezier(0.68,-0.55,0.265,1.55)'].map((e) => ({ label: e, value: e }));

interface Props { value: Animation[]; onChange(v: Animation[]): void }

export function AnimationsEditor({ value, onChange }: Props) {
  const update = (i: number, patch: Partial<Animation>) => onChange(value.map((a, j) => (j === i ? { ...a, ...patch } : a)));
  const remove = (i: number) => onChange(value.filter((_, j) => j !== i));
  const add = () => onChange([...value, { preset: 'fadeIn', trigger: 'enter', duration: 600, delay: 0, iterations: 1, easing: 'ease-out' }]);

  return (
    <div>
      {value.length > 0 && (
        <Collapse
          size="small"
          defaultActiveKey={value.map((_, i) => String(i))}
          items={value.map((a, i) => ({
            key: String(i),
            label: `${i + 1}. ${PRESET_LIST.find((p) => p.name === a.preset)?.label ?? a.preset}`,
            extra: <Button size="small" type="text" danger icon={<DeleteOutlined />} onClick={(e) => { e.stopPropagation(); remove(i); }} />,
            children: (
              <>
                <Field label="效果"><Select style={{ width: '100%' }} value={a.preset} options={PRESET_OPTIONS} onChange={(v) => update(i, { preset: v })} /></Field>
                <Field label="触发" inline>
                  <Select size="small" style={{ width: 120 }} value={a.trigger} options={[{ label: '进入页面', value: 'enter' }, { label: '点击', value: 'click' }]} onChange={(v) => update(i, { trigger: v })} />
                </Field>
                <Space style={{ width: '100%' }} wrap>
                  <Field label="时长 ms" inline><InputNumber size="small" style={{ width: 90 }} min={0} step={100} value={a.duration} onChange={(v) => update(i, { duration: v ?? 0 })} /></Field>
                  <Field label="延迟 ms" inline><InputNumber size="small" style={{ width: 90 }} min={0} step={100} value={a.delay} onChange={(v) => update(i, { delay: v ?? 0 })} /></Field>
                </Space>
                <Field label="次数（0 为无限）" inline><InputNumber size="small" style={{ width: 90 }} min={0} value={a.iterations} onChange={(v) => update(i, { iterations: v ?? 1 })} /></Field>
                <Field label="缓动"><Select style={{ width: '100%' }} value={a.easing} options={EASINGS} onChange={(v) => update(i, { easing: v })} /></Field>
              </>
            ),
          }))}
        />
      )}
      <Button block size="small" icon={<PlusOutlined />} style={{ marginTop: 8 }} onClick={add}>添加动画</Button>
    </div>
  );
}
